import {
    useState,
    useEffect,
    useMemo,
    useCallback,
} from 'react';

import { webLibSdk } from 'helpers';
import { STANDARD_ALLOCATION_TYPE } from '_constants/allocationTypes';
import StyledTabs from './styles';
import AllocatedAddresses from './AllocatedAddresses';
import History from './History';
import SetAllocation from './SetAllocation/StandardSetAllocation';
import Filtering from './Filtering';
import Tabs from './Tabs';

const StandardAllocationType = ({ currentAddress, setHasSomeRole }) => {
    const [tab, setTab] = useState('allocatedAddresses');
    const [filterDate, setFilterDate] = useState(null);
    const [addressSearch, setAddressSearch] = useState('');

    const [types, setTypes] = useState([]);
    const [typeRoles, setRoleTypes] = useState({});

    useEffect(() => {
        const getTypes = async () => {
            const allocationTypes = await webLibSdk.allocationTypes();
            setTypes(allocationTypes);

            // eslint-disable-next-line no-restricted-syntax
            for (const role of ['Founders', 'Advisors', 'TokenSale', 'MarketingPR', 'Ecosystem']) {
                webLibSdk.hasRole(currentAddress, role).then((res) => {
                    setRoleTypes((oldVal) => ({ ...oldVal, [role]: res }));
                });
            }
        };

        getTypes();
    }, [currentAddress]);

    useEffect(() => {
        setHasSomeRole(Object.values(typeRoles).includes(true));
    }, [typeRoles]);

    const filteredTypes = useMemo(() => types.filter(({ type }) => {
        if (type === 'Founders' && typeRoles.Founders) return true;
        if (type === 'Advisors' && typeRoles.Advisors) return true;
        if (['Marketing', 'Partners'].includes(type) && typeRoles.MarketingPR) return true;
        if (['Private1', 'Private2', 'Public', 'Presale'].includes(type) && typeRoles.TokenSale) return true;
        if (type === 'Ecosystem' && typeRoles.Ecosystem) return true;
        if (type === 'Blockchain' && typeRoles.Blockchain) return true;

        return false;
    }), [types, typeRoles]);

    const updateTab = useCallback((val) => {
        setTab(val);
        setFilterDate(null);
        setAddressSearch('');
    }, []);

    return (
        <StyledTabs className="container">
            {process.env.REACT_APP_OPEN_TABLE_DATA === 'TRUE' || filteredTypes.length
                ? (
                    <>
                        {!!filteredTypes.length && <SetAllocation types={filteredTypes} />}
                        <Tabs
                            tab={tab}
                            updateTab={updateTab}
                        />
                        <Filtering
                            filterDate={filterDate}
                            setFilterDate={setFilterDate}
                            addressSearch={addressSearch}
                            setAddressSearch={setAddressSearch}
                        />
                        <div>
                            <AllocatedAddresses
                                isShown={tab === 'allocatedAddresses'}
                                types={filteredTypes}
                                initialTypes={types}
                                filterDate={filterDate}
                                addressSearch={addressSearch}
                                distributionAllocationType={STANDARD_ALLOCATION_TYPE}
                            />
                            <History
                                isShown={tab === 'history'}
                                filterDate={filterDate}
                                addressSearch={addressSearch}
                                distributionAllocationType={STANDARD_ALLOCATION_TYPE}
                            />
                        </div>
                    </>
                )
                : null}
        </StyledTabs>
    );
};

export default StandardAllocationType;
